import { createContext } from 'react';
import type { AccessCapabilities, AccessPreview } from '@/types/access';
import { EMPTY_CAPABILITIES } from '@/types/access';

export interface AuthUser {
  id: string;
  first_name: string;
  last_name: string;
  email?: string | null;
  role?: string | null;
  access?: string | null;
}

export interface AuthSessionPayload {
  user: AuthUser;
  sessionExpiresAt?: string;
  capabilities: AccessCapabilities;
  preview: AccessPreview | null;
  group_slug: string | null;
}

export interface AuthContextValue {
  user: AuthUser | null;
  isAuthenticated: boolean;
  loading: boolean;
  capabilities: AccessCapabilities;
  preview: AccessPreview | null;
  group_slug: string | null;
  /** Единый клиентский контракт: пользователь + время истечения сессии с сервера. */
  setSession: (session: AuthSessionPayload) => void;
  getSession: () => AuthSessionPayload | null;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export { EMPTY_CAPABILITIES };
